import { AppSettings } from '../../app.settings';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {ApiService} from '../../services/api/api.service';
import {SessionService} from '../../services/session/session.service';
import { TabStorageService } from '../../services/tabstorage/tabstorage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(
      public apiService: ApiService,
      private sessionService: SessionService,
      public router: Router,
      private tabStorageService: TabStorageService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const hasIdToken = TabStorageService.hasCognitoIdToken();
    const isApiAuthenticated: boolean = this.apiService.isAuthenticated();
    if (!isApiAuthenticated || !hasIdToken || this.sessionService.isAbsoluteSessionExpired()) {
      this.clearLocalStorageAndRedirectUser(state);
      return false;
    } else {
      return true;
    }
  }

  clearLocalStorageAndRedirectUser(state: RouterStateSnapshot): void {
    this.sessionService.loginUrl = state.url;
    this.tabStorageService.clearCurrentTabSession();
    void this.router.navigate(['/login'], {queryParams: AppSettings.getLocalNavigationQueryParams()}).then((): void => window.location.reload());
  }

}
